import React from 'react'
import { Form } from 'react-bootstrap'

const Selector = ({
    options = [],
    value = '',
    onChange = () => {},
}) => {

    const renderOption = (option, key) => {
        return (
            <option key={key} value={option.value}>{option.label}</option>
        )
    }

    return (
        <Form.Control
            as="select"
            value={value || ''}
            onChange={e => onChange(e.target.value)}
        >
            <option value=''>Not used</option>
            {options.map(renderOption)}
        </Form.Control>
    )
}

export default Selector